import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import ApiCalling from "../../ApiServices/ApiCalling";
import AuthInfoObj from "../../ApiServices/AuthInfoObj";
import { APPID, DOMAIN_NAME, VERSION, REFERER } from "../../Config.js";

const PaymentPageSidebar = () => {
  const isLoggedIn =
    !!sessionStorage.getItem("session") &&
    !!sessionStorage.getItem("sessionID");

  const [balanceData, setBalanceData] = useState();
  const getBalanceUser = async () => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetBalance",
        data: {},
        headers: {
          appID: APPID,
          version: VERSION,
          domain: DOMAIN_NAME,
          userID: AuthInfoObj().userID,
          sessionID: AuthInfoObj().sessionID,
          session: AuthInfoObj().session,
        },
      });

      if (res?.statuscode === 1) {
        setBalanceData(res?.data);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getBalanceUser :", error);
    }
  };

  useEffect(() => {
    getBalanceUser();
  }, []);

  return (
    <>
      <div className="main-navigation ">
        <div className="navigation-list  navigation-primary">
          <div className="list-track">
            <div className="primary-list">
              <div className="sidebar-list">
                <NavLink to="/">
                  <div className="sidebar-item">
                    <img
                      src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/hamburger/tabs_home_inactive.png"
                      alt="Freecharge home icon"
                      loading="lazy"
                    />
                    <span className="label-text" title="Home">
                      Home
                    </span>
                  </div>
                </NavLink>

                {isLoggedIn && (
                  <>
                    <NavLink to="/transactionreport">
                      <div className="sidebar-item">
                        <img
                          src="	https://pwa-cdn.freecharge.in/pwa-static/pwa/images/accountSettings/transactions.svg"
                          alt="Transaction Report"
                          loading="lazy"
                        />
                        <span
                          className="label-text"
                          title="Loans & Credit Card"
                        >
                          Transaction Report
                        </span>
                      </div>
                    </NavLink>
                    <NavLink to="/ledgerreport">
                      <div className="sidebar-item">
                        <img
                          src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/hamburger/wallet.png"
                          alt="Wallet Ledger"
                          loading="lazy"
                        />
                        <span className="label-text" title="Free Credit Score">
                          Wallet Ledger
                        </span>
                      </div>
                    </NavLink>
                    <NavLink to="/profile">
                      <div className="sidebar-item">
                        <img
                          src="	https://pwa-cdn.freecharge.in/pwa-static/pwa/images/hamburger/accounts.png"
                          alt="Profile"
                          loading="lazy"
                        />
                        <span className="label-text" title="Free Credit Score">
                          Profile
                        </span>
                      </div>
                    </NavLink>
                    {balanceData?.isWalletToWallet && (
                      <NavLink to="/walletTotransfer">
                        <div className="sidebar-item">
                          <img
                            src="	https://pwa-cdn.freecharge.in/pwa-static/pwa/images/hamburger/my_transactions.png"
                            alt="Profile"
                            loading="lazy"
                          />
                          <span
                            className="label-text"
                            title="Free Credit Score"
                          >
                            Wallet to Wallet Transfer
                          </span>
                        </div>
                      </NavLink>
                    )}
                    {balanceData?.isB2cMembershipRePurchase && (
                      <NavLink to="/updatemembership">
                        <div className="sidebar-item">
                          <img
                            src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/hamburger/blog_icon.png"
                            alt="Profile"
                            loading="lazy"
                          />
                          <span
                            className="label-text"
                            title="Free Credit Score"
                          >
                            Update Membership
                          </span>
                        </div>
                      </NavLink>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentPageSidebar;
